import React from 'react'

import { Formik, Field } from 'formik'

import { ZariContext } from '_zari/context'
import { Form, Table, Col, Button } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as TiposCambioService from 'services/tiposCambio.service'

const RowTemplate = ({ rowInfo }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return rowInfo
  }, [rowInfo])

  const onSubmit = React.useCallback(
    async data => {
      const validData = {
        dia: parseFloat(data.dia),
        mes: parseFloat(data.mes),
        anio: parseFloat(data.anio),
        precioCompraDolares: parseFloat(data.precioCompraDolares),
        precioVentaDolares: parseFloat(data.precioVentaDolares),
        precioCompraEuros: parseFloat(data.precioCompraEuros),
        precioVentaEuros: parseFloat(data.precioVentaEuros)
      }

      await TiposCambioService.actualizarTipoCambio(validData)
        .then(({ data }) => {
          __zariContext.snack('success', 'Se ha actualizado el registro.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const onKeyDown = React.useCallback((nextNodeId, e) => {
    KeyEventUtil.leaveOnEnterOrTab(nextNodeId, e)
  }, [])

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={formInitialValues}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ values, isSubmitting, errors, touched, handleSubmit }) => (
        <Table.Row>
          <Table.Cell align='center'>{values.fecha}</Table.Cell>
          <Table.Cell>
            <Field name='precioCompraEuros'>
              {({ field }) => (
                <Form.Group className='mb-0'>
                  <Col md={12}>
                    <Form.InputNumber
                      {...field}
                      id={`number-${values.fecha}-precioCompraEuros`}
                      disabled={isSubmitting}
                      isInvalid={errors.precioCompraEuros && touched.precioCompraEuros}
                      onKeyDown={e => onKeyDown(`number-${values.fecha}-precioVentaEuros`, e)}
                    />
                    {errors.precioCompraEuros && touched.precioCompraEuros ? (
                      <Form.Feedback type='invalid'>
                        {errors.errors.precioCompraEuros}
                      </Form.Feedback>
                    ) : null}
                  </Col>
                </Form.Group>
              )}
            </Field>
          </Table.Cell>
          <Table.Cell>
            <Field name='precioVentaEuros'>
              {({ field }) => (
                <Form.Group className='mb-0'>
                  <Col md={12}>
                    <Form.InputNumber
                      {...field}
                      id={`number-${values.fecha}-precioVentaEuros`}
                      disabled={isSubmitting}
                      isInvalid={errors.precioVentaEuros && touched.precioVentaEuros}
                      onKeyDown={e => onKeyDown(`button-${values.fecha}`, e)}
                    />
                    {errors.precioVentaEuros && touched.precioVentaEuros ? (
                      <Form.Feedback type='invalid'>{errors.errors.precioVentaEuros}</Form.Feedback>
                    ) : null}
                  </Col>
                </Form.Group>
              )}
            </Field>
          </Table.Cell>
          <Table.Cell>
            <Button id={`button-${values.fecha}`} tiny onClick={handleSubmit}>
              Actualizar
            </Button>
          </Table.Cell>
        </Table.Row>
      )}
    </Formik>
  )
}

export default React.memo(RowTemplate)
